import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { updateSubmission } from 'store/Forms/actions'
import { fetchUserStores } from 'store/Forms/actions'

function SubmissionLocationsModal({
  id,
  userId,
  setShowLocationsModal,
  storeIds,
  setSubmissionStoreIdsState,
  submissionStoreNames,
  setSubmissionStoresState,
}) {
  const modalRef = useRef(null)
  const dispatch = useDispatch()

  const { userStores } = useSelector((store) => store.form)
  const [selectedStores, setSelectedStores] = useState(storeIds || [])
  const [selectedStoreNames, setSelectedStoreNames] = useState([])

  const selectStore = (storeId) => {
    if (!selectedStores.includes(storeId)) {
      setSelectedStores([...selectedStores, storeId])
    } else {
      setSelectedStores(selectedStores.filter((id) => id !== storeId))
    }
  }

  const selectStoreName = (storeName) => {
    if (!selectedStoreNames.includes(storeName)) {
      setSelectedStoreNames([...selectedStoreNames, storeName])
    } else {
      setSelectedStoreNames(
        selectedStoreNames.filter((name) => name !== storeName)
      )
    }
  }

  useEffect(() => {
    dispatch(fetchUserStores(userId))
  }, [userId, dispatch])

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowLocationsModal(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [setShowLocationsModal])

  useEffect(() => {
    if (
      submissionStoreNames &&
      submissionStoreNames.length &&
      submissionStoreNames?.at(0) !== '-'
    ) {
      setSelectedStoreNames(submissionStoreNames.split(','))
    }
  }, [submissionStoreNames])

  console.log(selectedStoreNames, 'leart65')

  return (
    <div
      className='shadow-lg bg-white rounded p-3 title-modal'
      style={{ top: '50px' }}
      ref={modalRef}
    >
      <h4 className='mb-3'>Form Submission Locations</h4>
      {userStores?.map((store) => (
        <div
          key={store.store_id}
          className='custom-control custom-checkbox mb-3'
          style={{ zIndex: '0' }}
        >
          <input
            className='custom-control-input'
            id={`store-${store.store_id}`}
            checked={selectedStores.includes(store.store_id)}
            type='checkbox'
            onChange={() => {
              selectStoreName(store.name)
              selectStore(store.store_id)
            }}
          />
          <label
            className='custom-control-label'
            htmlFor={`store-${store.store_id}`}
          >
            {store.name}
          </label>
        </div>
      ))}
      <div className='d-flex align-items-center mt-5'>
        <button
          className='btn btn-info mr-2'
          onClick={() => {
            dispatch(
              updateSubmission(id, { stores: JSON.stringify(selectedStores) })
            )
            setSubmissionStoresState(selectedStoreNames)
            setSubmissionStoreIdsState(selectedStores)
            setShowLocationsModal(false)
          }}
        >
          Save
        </button>
        <button
          className='btn btn-secondary'
          onClick={() => {
            setShowLocationsModal(false)
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  )
}

export default SubmissionLocationsModal
